// Desenvolvido Front-End e Design por Tamires Silva 
// Desenvolvido Back-End, Banco de Dados e Implementação por Raul Barboza

import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Provider } from "react-redux";
import 'font-awesome/css/font-awesome.min.css';
import store from "./store/store";
import PrivateRouter from "./components/PrivateRouter/PrivateRouter";
import PublicRouter from "./components/PublicRouter/PublicRouter";
import GAListener from "./GAListener";


import ToolPage from './pages/extern/ToolPage';
import Showcase from './pages/extern/Showcase/ShowcasePage';
import SpecsPage from './pages/extern/SpecsPage';
import FaqPage from './pages/extern/FaqPage';

import LoginPage from './pages/general/LoginPage';
import ResetLoginPage from './pages/general/ResetLoginPage';
import RegisterPage from './pages/general/RegisterPage';

import ErrorOrMaintenancePage from './pages/general/ErrorOrMaintenancePage/ErrorOrMaintenancePage';

import Home from './pages/intern/general/Home';
import CriarDashboardPage from './pages/intern/admin/CriarDashboardPage';
import Showcases from './pages/intern/admin/showcase/Showcases';
import EditarDashboardPage from './pages/intern/admin/EditarDashboardPage'
import CriarUsuarioPage from './pages/intern/admin/CriarUsuarioPage';
import EditarUsuarioPage from './pages/intern/admin/EditarUsuarioPage';
import CriarGrupoPage from './pages/intern/admin/CriarGrupoPage'
import EditarGrupoPage from './pages/intern/admin/EditarGrupoPage'
import DashboardViewer from './pages/intern/general/DashboardViewerPage/dashboardviewer';
import GerenciarPage from './pages/intern/admin/GerenciarPage';
import AprovacaoDeAcessosPage from './pages/intern/admin/AprovacaoDeAcessosPage'
import PerfilPage from './pages/intern/general/PerfilPage/PerfilPage';

import LoadingScreenPage from './pages/general/LoadingScreenPage/LoadingScreenPage';

import ProposalsReviewPage from './pages/intern/admin/propostaComercial/pages/ProposalsReviewPage';
import DCOEstimator from './pages/intern/admin/propostaComercial/pages/DCOEstimatorOld';
import AdminConfigPropostaComercial from './pages/intern/admin/propostaComercial/pages/AdminConfigPage/AdminConfig'

import ArticleApiFT from './pages/dataArticle/ArticleApiFT';
import ArticleDynamicCreativeGuidelines from './pages/dataArticle/ArticleDynamicCreative';
import Briefing from './pages/dataArticle/Briefing';

import Validador from './pages/intern/admin/validadorMIQ/Validador';

const App = () => {
  const [isMaintenance, setIsMaintenance] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsMaintenance(true);
    }, 3000);
  }, []);


  return (
    <Provider store={store}>
      <Router>
        {/* Ouvinte do Google Analytics */}
        <GAListener />

        <Routes>

          {/* Parte de acesso externa */}
          <Route path="/" element={<PublicRouter> <LoginPage /> </PublicRouter>} />
          <Route path="/reset" element={<PublicRouter> <ResetLoginPage /> </PublicRouter>} />
          <Route path="/register" element={<PublicRouter> <RegisterPage /> </PublicRouter>} />

          {/* Parte de externa, sem ncessidade de acesso */}
          <Route path="/tool" element={<PublicRouter> <ToolPage /> </PublicRouter>} />
          <Route path="/showcase" element={<PublicRouter> <Showcase /> </PublicRouter>} />
          <Route path="/specs" element={<PublicRouter> <SpecsPage /> </PublicRouter>} />
          <Route path="/faq" element={<PublicRouter> <FaqPage /> </PublicRouter>} />

          {/* Parte dos artigos externos, sem ncessidade de acesso */}
          <Route path="/article/api-ft" element={<PublicRouter><ArticleApiFT /></PublicRouter>} />
          <Route path="/article/dynamic-creative-guidelines" element={<PublicRouter><ArticleDynamicCreativeGuidelines /></PublicRouter>} />
          <Route path="/briefing-campaign" element={<PublicRouter><Briefing /></PublicRouter>} />



          {/* Sistema interno */}
          <Route path="/dashboard" element={<PrivateRouter><Home /></PrivateRouter>} />
          <Route path="/perfil" element={<PrivateRouter><PerfilPage /></PrivateRouter>} />

          <Route path="/criarDash" element={<PrivateRouter><CriarDashboardPage /></PrivateRouter>} />
          <Route path="/editarDash/:id" element={<PrivateRouter><EditarDashboardPage /></PrivateRouter>} />

          <Route path="/criarUsuario" element={<PrivateRouter><CriarUsuarioPage /></PrivateRouter>} />
          <Route path="/editarUsuario/:id" element={<PrivateRouter><EditarUsuarioPage /></PrivateRouter>} />

          <Route path="/showcases" element={<PrivateRouter><Showcases /></PrivateRouter>} />

          <Route path="/criarGrupo" element={<PrivateRouter><CriarGrupoPage /></PrivateRouter>} />
          <Route path="/editarGrupo/:id" element={<PrivateRouter><EditarGrupoPage /></PrivateRouter>} />

          <Route path="/gerenciar" element={<PrivateRouter><GerenciarPage /></PrivateRouter>} />
          <Route path="/aprovacaoDeAcessos" element={<PrivateRouter><AprovacaoDeAcessosPage /></PrivateRouter>} />

          <Route path="/ProposalsReviewPage" element={<PrivateRouter><ProposalsReviewPage /></PrivateRouter>} />
          <Route path="/propostaComercial" element={<PrivateRouter><DCOEstimator /></PrivateRouter>} />
          <Route path="/validadorMIQ" element={<PrivateRouter><Validador /></PrivateRouter>} />
          <Route path="/adminConfigPropostaComercial" element={<PrivateRouter><AdminConfigPropostaComercial /></PrivateRouter>} />


          <Route path="/render/:id" element={<PrivateRouter><DashboardViewer /></PrivateRouter>} />

          {/* A rota "loading" captura qualquer URL decarregamento */}
          <Route path="/loading" element={<LoadingScreenPage isMaintenance={isMaintenance} />} />

          {/* A rota "*" captura qualquer URL não definida e exibe a página de erro ou manutenção */}
          <Route path="*" element={<ErrorOrMaintenancePage isMaintenance={isMaintenance} />} />

        </Routes>
      </Router>
    </Provider>



  );
};

export default App;
